/**
 *
 * StyledLink
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    textDecoration: 'none',
    zIndex: 99,
  },
}));
function StyledLink({
  link,
  linkState,
  onClick,
  children,
  className,
  ariaLabel,
}) {
  const classes = useStyles();
  const to = linkState
    ? {
        pathname: typeof link === 'string' ? link : link?.pathname,
        state: linkState,
      }
    : link;
  return (
    <Link
      to={to}
      onClick={onClick}
      className={_classNames(classes.root, { [className]: !!className })}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  );
}

StyledLink.propTypes = {
  children: PropTypes.node,
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  linkState: PropTypes.object,
  onClick: PropTypes.func,
};

export default StyledLink;
